import { useState, useCallback } from 'react'

export interface UseFilterPanelReturnValue {
  isOpen: boolean
  toggle: () => void
  open: () => void
  close: () => void
}

export const useFilterPanel = (): UseFilterPanelReturnValue => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    toggle,
    open,
    close,
  }
}
